import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  Box,
  IconButton,
} from "@mui/material";
import { ReactComponent as AddIcon } from "../../Assets/Icons/AddIcon.svg";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/SearchIcon.svg";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import { ReactComponent as PharmacyHomeIcon } from "Assets/Icons/PharmsmartIcon/PharmacyHomeIcon.svg";
import { connect } from "react-redux";
import {
  RESET_PHARMACY_STATE,
  START_DELETE_PHARMACY,
  START_GET_PHARMACIES_LIST,
} from "../../Actions/PharmacyAction";
import { useIntersection } from "../../Hooks/customHooks";
import _ from "underscore";
import "../../Sass/Common.scss";
import {
  getClearObject,
  getLocalStorage,
  setLocalStorage,
  getNewOrder,
} from "../../utils/generalUtils";
import PharmacyTable from "./PharmacyTable";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import TableColumnShowMenu from "../Common/Table/TableColumnShowMenu";
import { ReactComponent as SettingIcon } from "Assets/Icons/SettingsIcon.svg";
import HtmlTooltip from "../../Components/Common/HtmlTooltipMain";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import useViewport from "../../Hooks/useViewport";
const AddPharmacyDialog = React.lazy(() => import("./AddPharmacyDialog"));
const ConfirmationDialog = React.lazy(() =>
  import("../../Components/Common/Dialog/ConfirmationDialog")
);

const useStyle = makeStyles((theme) => ({
  rsPharmaciesHeader: {
    // marginBottom: "-13px",
    // display: "flex-inline",
    display: " flex",
    padding: " 6px 6px",
    background: "#333",
    alignItems: "center",
    justifyContent: "space-between",
    // margin-bottom: 20px;
    // display: flex;
    // justify-content: end;

    "&>button": {
      marginLeft: "5px",
      fontSize: "14px",
      height: "36px",
      [theme.breakpoints.down("420")]: {
        marginTop: "5px ",
      },
    },
    "&>div": {
      // marginLeft: "11px",
      // width: "24% !important",
      height: "37px !important",
      marginBottom: "0",
      [theme.breakpoints.down("600")]: {
        // marginTop: "5px ",
      },
      "&>button": {
        height: "37px !important",
        marginLeft: "5px",
      },
      "&>div": {
        height: "37px !important",
        "&>div": {
          height: "37px !important",
        },
      },
      // [theme.breakpoints.down("600")]: {
      //   display: "block",
      //   justifyContent: "end",
      // },
    },
    [theme.breakpoints.down(870)]: {
      flexDirection: "column !important",
    },
    [theme.breakpoints.down(768)]: {
      flexDirection: "row !important",
    },
    [theme.breakpoints.down(555)]: {
      flexDirection: "column !important",
    },
    // [theme.breakpoints.down("600")]: {
    //   display: "block",
    //   justifyContent: "end",
    // },
  },
  managePageH: {
    // marginTop: "5px",
    "& .MuiTableContainer-root": {
      // maxHeight: "calc(99vh - 200px) !important",
      // padding: "13px !important",
      maxHeight: "calc(96vh - 148px) !important",
      [theme.breakpoints.between("769", "869")]: {
        maxHeight: "calc(100vh - 230px) !important",
      },
      [theme.breakpoints.down("769")]: {
        maxHeight: "calc(100vh - 220px) !important",
      },
      padding: "0px !important",
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              lineHeight: "1.2rem",
              padding: "11px 16px",
              borderBottom: "3px solid #dddddd",
              borderLeft: "3px solid #dddddd",
              "&:first-child": {
                whiteSpace: "nowrap",
                position: "sticky",
                left: "0px",
                zIndex: 4,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                position: "sticky",
                left: 0,
                zIndex: 1,
                right: "0px",
              },
              " &:nth-child(3)": {
                position: "sticky",
                left: 0,
                zIndex: 1,
                right: "0px",
              },
              "&:last-child": {
                position: "sticky",
                right: "0px",
                padding: "0 10px !important",
                zIndex: 4,
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "sticky",
                left: "0px",
                zIndex: 3,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 0,
                right: "0px",
              },
              " &:nth-child(3)": {
                background: "#ffffff",
                position: "sticky",
                left: 0,
                zIndex: 0,
                right: "0px",
              },
              "&:last-child": {
                background: "#ffffff",
                position: "sticky",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  globalSettingIcon: {
    // margin: "-9px 0px 5px",
    margin: "0 5px 0 0",
  },
  search: {
    marginTop: "0px !important",
    marginRight: "11px !important",
    [theme.breakpoints.down(870)]: {
      marginRight: "4px !important",
    },
  },
  rsButtonHowtoIcon: {
    // background: "#7bc044 !important",
    padding: "10px !important",
    borderRadius: "5px !important",
    marginLeft: "4px",
    "&>span": {
      marginLeft: "-8px",
    },
    "&>svg": {
      "&>path": {
        fill: "white !important",
      },
    },
  },
  rsHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    // width: "100%",
    "&>button": {
      marginLeft: "20px",
      fontSize: "14px",
    },
    "&>div": {
      width: "200px",
      marginRight: "5px",
    },
    [theme.breakpoints.down(870)]: {
      alignItems: "flex-start",
      width: "100%",
      marginLeft: "10px",
      marginTop: "4px",
    },
    [theme.breakpoints.down(768)]: {
      alignItems: "unset",
      width: "unset",
      marginLeft: "unset",
      marginTop: "unset",
    },
    [theme.breakpoints.down(555)]: {
      alignItems: "flex-start",
      width: "100%",
      marginLeft: "10px",
      marginTop: "4px",
    },
  },
  rsButtonHeader: {
    [theme.breakpoints.down(870)]: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      "&>div": {
        width: "200px",
        marginRight: "5px",
      },
    },
    [theme.breakpoints.down(409)]: {
      flexDirection: "column",
      width: "100%",
      alignItems: "flex-end",
      "&>div:nth-child(2)": {
        marginTop: "5px !important",
        marginRight: "0px !important",
      },
    },
    [theme.breakpoints.down(365)]: {
      "&>div:nth-child(2)": {
        width: "147px !important",
      },
    },
  },
}));

/** head title */
const tableCells = {
  name: {
    id: "name",
    label: "PHARMACY NAME",
    sortable: true,
    show: true,
    showValue: false,
  },
  email: {
    id: "email",
    label: "EMAIL",
    sortable: true,
    show: true,
    showValue: true,
  },
  address: {
    id: "address",
    label: "ADDRESS",
    sortable: true,
    show: true,
    showValue: true,
  },
  action: {
    id: "action",
    label: "ACTIONS",
    sortable: false,
    show: true,
    showValue: false,
  },
};

const PharmaciesMain = (props) => {
  const {
    getPharmacyListAction,
    pharmaciesList,
    deletePharmacyAction,
    deletePharmacyData,
    resetPharmacyState,
    loginUserDetail,
  } = props;
  const classes = useStyle();
  const [addPharmacy, setAddPharmacy] = useState(false);
  const [editPharmacyData, setEditPharmacyData] = useState({});
  const [deletePharmacy, setDeletePharmacy] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const [searchValue, setSearchValue] = useState("");
  const [pharmacyRecordActionType, setPharmacyRecordActionType] = useState("");
  const pharmacyListRecordLimit = 20;
  const showCreateAndAction =
    ["admin", "super_admin"].indexOf(loginUserDetail?.data?.data?.role) !== -1;
  const [columnSortingOrder, setColumnSortingOrder] = useState({
    orderBy: "",
    sortBy: "asc",
  });
  const [columnsPopperAnchorEl, setColumnsPopperAnchorEl] = useState(null);
  const [patientCount, setPatientCount] = useState("");
  const [openTableColumn, setOpenTableColumn] = useState(false);
  const [tableColumns, setTableColumns] = useState({});
  const activeColumns =
    getLocalStorage("dynamicColumnPharmacy")?.split(",") || [];
  const columnSequence =
    getLocalStorage("dynamicColumnSequencePharmacy")?.split(",") || [];

  let { width } = useViewport();
  /** Pharmacy Collection Api call main Function */
  const getList = (params = {}) => {
    let payload = {
      offset: 0,
      limit: pharmacyListRecordLimit,
      q: searchValue,
      order_by: params.orderBy || columnSortingOrder.orderBy,
      sort_by: (params.sortBy || columnSortingOrder.sortBy).toUpperCase(),
    };

    payload = {
      ...payload,
      ...params,
    };
    getPharmacyListAction(getClearObject(payload));
  };

  /** get list  */
  useEffect(() => {
    let payload = {
      offset: 0,
      limit: 20,
    };
    if (getLocalStorage("urlpharmacy") == "pharmacy") {
      getPharmacyListAction(payload);
      setLocalStorage("urlpharmacy", "none");
    }
    return () => {
      if (window.location.pathname !== "/pharmacies") {
        // getPharmacyListAction(payload);
        // window.onbeforeunload = null;
      }
    };
    // getList();
  }, []);

  /** Pagination UseEffect */
  useEffect(() => {
    if (entry.isIntersecting) {
      if (
        pharmaciesList?.data?.list?.length !=
        pharmaciesList?.data?.filterd_record
      ) {
        getList({
          offset: pharmaciesList?.data?.list?.length,
          limit: pharmacyListRecordLimit,
          order_by: columnSortingOrder.orderBy,
          sort_by: columnSortingOrder.sortBy.toUpperCase(),
        });
      }
    }
  }, [entry]);

  /** Delete pharmacy Function */
  const handleDelete = () => {
    deletePharmacyAction(deleteId);
  };

  /** Delete pharmacy loading UseEffect */
  useEffect(() => {
    if (
      !deletePharmacyData?.loading &&
      Object.keys(deletePharmacyData?.data)?.length
    ) {
      setDeletePharmacy(false);
      setDeleteId("");
      resetPharmacyState("deletePharmacyData", "");
    }
  }, [deletePharmacyData]);

  /** Search debounce useRef */
  const searchUserDebounce = useRef(
    _.debounce((searchString, otherStateValues = {}) => {
      getList({
        ...(searchString && {
          q: searchString,
        }),
        ...otherStateValues,
      });
    }, 500)
  );

  /** Handle Search pharmacy function */
  const handleSearch = (newValue) => {
    searchUserDebounce.current(newValue, {
      order_by: columnSortingOrder.orderBy,
      sort_by: columnSortingOrder.sortBy.toUpperCase(),
    });
  };

  /**   Detect column order changes */
  useEffect(() => {
    if (columnSortingOrder.orderBy && columnSortingOrder.sortBy) {
      getList();
    }
  }, [columnSortingOrder.orderBy, columnSortingOrder.sortBy]);

  //Set value after page refresh useEffect
  useLayoutEffect(() => {
    let allColumns = tableCells;

    if (activeColumns.length > 0) {
      Object.keys(allColumns)?.map((key) => {
        if (allColumns[key].showValue) {
          if (activeColumns.indexOf(allColumns[key].id) !== -1) {
            allColumns[key].show = true;
          } else {
            allColumns[key].show = false;
          }
        }
      });
    }
    allColumns = getNewOrder(columnSequence, allColumns);
    setTableColumns(allColumns);
  }, []);

  return (
    <>
      <Grid>
        {width > 865 && (
          <Grid className={classes.rsPharmaciesHeader} container>
            {/* <Grid className="rsHeader"}> */}
            <div className={classes.rsButtonHeader}>
              {showCreateAndAction && (
                <HtmlTooltip title="" className="hoverAlign">
                  {/* <IconButton
         className={clsx("btn_green", classes.rsButtonHowtoIcon)}
         variant="contained"
         onClick={() => {
           setPharmacyRecordActionType("createNewPharmacy");
           setAddPharmacy(true);
         }}
       >
         <PrimaryIcon
           width="20px"
           cursor="pointer"
           icon={PharmacyHomeIcon}
         />
       </IconButton> */}
                  <Button
                    className={classes.rsButtonHowtoIcon}
                    variant="contained"
                    startIcon={
                      <PrimaryIcon
                        icon={AddIcon}
                        color="white"
                        width="16px"
                        height="16px"
                      />
                    }
                    onClick={() => {
                      setPharmacyRecordActionType("createNewPharmacy");
                      setAddPharmacy(true);
                    }}
                  >
                    Create Pharmacy
                  </Button>
                </HtmlTooltip>
              )}
            </div>
            <div className={classes.rsHeader}>
              <TextField
                withPadding={true}
                medium
                secondary
                className={classes.search}
                placeholder="Search..."
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                  handleSearch(e?.target?.value);
                }}
                InputProps={{
                  endAdornment: (
                    <>
                      <InputAdornment position="end">
                        <PrimaryIcon width="20px" icon={SearchIcon} />
                      </InputAdornment>
                    </>
                  ),
                }}
              />
              <Box
                className="ColumnMain"
                onClick={(e) => {
                  setColumnsPopperAnchorEl(e.currentTarget);
                  setPharmacyRecordActionType("PharmacyDetails");
                  setOpenTableColumn(true);
                }}
              >
                <HtmlTooltip title="Columns">
                  <Box>
                    <Button
                      className="ColumnBtn"
                      // onClick={(e) => {
                      //   setColumnsPopperAnchorEl(e.currentTarget);
                      //   setPharmacyRecordActionType("PharmacyDetails");
                      //   setOpenTableColumn(true);
                      // }}
                    >
                      <PrimaryIcon
                        color="black"
                        width="20px"
                        icon={ViewWeekIcon}
                        cursor="pointer"
                      />
                      Columns
                      <PrimaryIcon
                        color="black"
                        width="30px"
                        icon={ArrowDropDownIcon}
                        cursor="pointer"
                      />
                    </Button>
                  </Box>
                </HtmlTooltip>
              </Box>
            </div>
            {/* </Grid> */}
            {/* <Box className="RsSetting">
   <HtmlTooltip title="Setting">
     <Box>
       <PrimaryIcon
         color="secondary"
         className={classes.globalSettingIcon}
         width="20px"
         icon={SettingIcon}
         cursor="pointer"
         onClick={() => {
           setPharmacyRecordActionType("PharmacyDetails");
           setOpenTableColumn(true);
         }}
       />
     </Box>
   </HtmlTooltip>
 </Box> */}
          </Grid>
        )}
        {width <= 865 && (
          <Grid className={classes.rsPharmaciesHeader}>
            <div className={classes.rsButtonHeader}>
              {showCreateAndAction && (
                <HtmlTooltip title="" className="hoverAlign">
                  <Button
                    className={classes.rsButtonHowtoIcon}
                    variant="contained"
                    startIcon={
                      <PrimaryIcon
                        icon={AddIcon}
                        color="white"
                        width="16px"
                        height="16px"
                      />
                    }
                    onClick={() => {
                      setPharmacyRecordActionType("createNewPharmacy");
                      setAddPharmacy(true);
                    }}
                  >
                    Create Pharmacy
                  </Button>
                </HtmlTooltip>
              )}
              <TextField
                withPadding={true}
                medium
                secondary
                className={classes.search}
                placeholder="Search..."
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                  handleSearch(e?.target?.value);
                }}
                InputProps={{
                  endAdornment: (
                    <>
                      <InputAdornment position="end">
                        <PrimaryIcon width="20px" icon={SearchIcon} />
                      </InputAdornment>
                    </>
                  ),
                }}
              />
            </div>
            <div className={classes.rsHeader}>
              <Box
                className="ColumnMain"
                onClick={(e) => {
                  setColumnsPopperAnchorEl(e.currentTarget);
                  setPharmacyRecordActionType("PharmacyDetails");
                  setOpenTableColumn(true);
                }}
              >
                <HtmlTooltip title="Columns">
                  <Box>
                    <Button
                      className="ColumnBtn"
                      // onClick={() => {
                      //   setPharmacyRecordActionType("PharmacyDetails");
                      //   setOpenTableColumn(true);
                      // }}
                    >
                      <PrimaryIcon
                        color="black"
                        width="20px"
                        icon={ViewWeekIcon}
                        cursor="pointer"
                      />
                      Columns
                      <PrimaryIcon
                        color="black"
                        width="30px"
                        icon={ArrowDropDownIcon}
                        cursor="pointer"
                      />
                    </Button>
                  </Box>
                </HtmlTooltip>
              </Box>
            </div>
          </Grid>
        )}
        <Grid className={clsx("common-table", classes.managePageH)}>
          <PharmacyTable
            loginUserDetail={loginUserDetail}
            columnSortingOrder={columnSortingOrder}
            setColumnSortingOrder={setColumnSortingOrder}
            showCreateAndAction={showCreateAndAction}
            pharmaciesList={pharmaciesList}
            setPharmacyRecordActionType={setPharmacyRecordActionType}
            setEditPharmacyData={setEditPharmacyData}
            setAddPharmacy={setAddPharmacy}
            setDeletePharmacy={setDeletePharmacy}
            setDeleteId={setDeleteId}
            setPatientCount={setPatientCount}
            setTarget={setTarget}
            tableCells={tableColumns}
          />
        </Grid>
      </Grid>
      <AddPharmacyDialog
        open={addPharmacy}
        pharmacyRecordActionType={pharmacyRecordActionType}
        editData={editPharmacyData}
        setEditData={setEditPharmacyData}
        setOpen={setAddPharmacy}
        getList={getList}
      />
      <ConfirmationDialog
        open={deletePharmacy}
        setOpen={setDeletePharmacy}
        title="Are you sure?"
        subTitle={`${
          patientCount > 0
            ? `This pharmacy cannot be deleted as it is already assigned to ${patientCount} ${
                patientCount > 1 ? "patients" : "patient"
              }.`
            : ""
        }`}
        body="You wan't be able to undo this pharmacy!"
        actionBtnTitle="Yes Delete It!"
        handleSubmit={handleDelete}
        loading={deletePharmacyData?.loading}
      />
      <TableColumnShowMenu
        open={openTableColumn}
        setOpen={setOpenTableColumn}
        anchorEl={columnsPopperAnchorEl}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        onOrderChange={(newOrder) => setTableColumns(newOrder)}
        tableCells={tableCells}
        moduleName={"pharmacy"}
        pharmacyRecordActionType={pharmacyRecordActionType}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  pharmaciesList: state.pharmacy.pharmaciesList,
  deletePharmacyData: state.pharmacy.deletePharmacyData,
  loginUserDetail: state.user.loginUserDetail,
});
const mapDispatchToProps = (dispatch) => ({
  getPharmacyListAction: (payload) =>
    dispatch({ type: START_GET_PHARMACIES_LIST, payload }),
  deletePharmacyAction: (id) => dispatch({ type: START_DELETE_PHARMACY, id }),
  resetPharmacyState: (key, payload) =>
    dispatch({ type: RESET_PHARMACY_STATE, key, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PharmaciesMain);
